mutation AddEditableGroupValue($value: String!, $editableGroupName: ID!, $campaignId: ID!) {
    addEditableGroupValue(editableGroupName: $editableGroupName, value: $value, campaignId: $campaignId) {
        _id
    }
}
